import classNames from 'classnames';
import _ from 'lodash';
import moment from 'moment';
import 'moment/locale/es';
import 'moment/locale/fr';
import 'moment/locale/en-ca';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as Utils from '../../../utilities/utils';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { toast } from 'react-toastify';

import './DaySelector.css';

const scrollTickInterval = 40;
// let loadError = false;

// Props
// fromMoment: moment.Moment;
// toMoment: moment.Moment;
// enabledDays: moment.Moment[];
// selectedDay: moment.Moment | null;
// handleSelectDay: (day: IPickableDay) => void;
// initialPageSize: number;

const mapStateToProps = (state) => {
  let language_id;
  let languageAbrev;
  try {
    language_id = state.bookingLocation.selectedLocation.language_id;
  } catch {
    language_id = state.language_id;
  }
  languageAbrev = (language_id === 3) ? "es" : (language_id === 2) ? "fr" : "en-ca";
  moment.locale(languageAbrev);
  return {
    language_id,
    languageObj: state.language.sub_components.day_selector_js,
    languageAbrev,
  };
}

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(class DaySelector extends Component {
  // daysClipperRef: HTMLElement | null;
  // daysRef: HTMLElement | null;
  // resizeInterval: number;
  // autoInterval: number;

  constructor(props) {
    super(props);

    this.state = {
      monthMin: moment(),
      monthMax: moment(),
      currentMonth: moment(),
      monthLists: [[], [], [], [], [], [], [], [], [], [], [], []],
      pageSize: this.props.initialPageSize,
      
      sliderPosition: 0,
      sliderOldPosition: 0,
      sliderDownPosition: 0,
      sliderContentSize: 0,
      sliderSize: 0,
      sliding: false,
      snapDuration: 300,
      snapPosition: 0,
      snapAmount: 0
    };

    this.updateDimensions = this.updateDimensions.bind(this);
    this.isTouch = 'ontouchstart' in window;
    this.startEvent = this.isTouch ? 'touchstart' : 'mousedown';
    this.moveEvent = this.isTouch ? 'touchmove' : 'mousemove';
    this.endEvent = this.isTouch ? 'touchend' : 'mouseup';
  }

  componentWillMount() {
    this.processDays(this.props.enabledDays, this.props.fromMoment, this.props.toMoment);
    this.updateDimensions();

    this.onMovePressed = this.onMovePressed.bind(this);
    this.onMovePressed = _.throttle(this.onMovePressed, 40);
    this.onWindowMouseUp = this.onWindowMouseUp.bind(this);

    this.onTouchMove = this.onTouchMove.bind(this);
    this.onTouchMove = _.throttle(this.onTouchMove, 40);
    this.onWindowTouchEnd = this.onWindowTouchEnd.bind(this);
  }

  componentDidMount() {
    window.addEventListener('resize', this.updateDimensions);
    this.resizeInterval = window.setInterval(this.updateDimensions, 250);
    this.updateDimensions();
    
    // back to where we were
    this.setState({ currentMonth: this.props.selectedDay ? this.props.selectedDay : this.state.currentMonth });
    this.scroll(this.props.initialSliderPosition);
  }

  componentWillUnmount() {
    window.clearInterval(this.resizeInterval);
    window.removeEventListener('resize', this.updateDimensions);
    window.removeEventListener(this.moveEvent, this.onMovePressed);
    window.removeEventListener(this.endEvent, this.onWindowMouseUp);
    window.removeEventListener(this.moveEvent, this.onTouchMove);
    window.removeEventListener(this.endEvent, this.onWindowTouchEnd);
    this.cancelScroll();
  }

  componentWillReceiveProps(nextProps) {
    // Only reprocess if something important changed
    // Don't want to do this every time a new date is selected
    try {
      if (nextProps.enabledDays !== this.props.enabledDays
        || nextProps.fromMoment.isSame(this.props.fromMoment, 'day') === false
        || nextProps.toMoment.isSame(this.props.toMoment, 'day') === false) {
        this.processDays(nextProps.enabledDays, nextProps.fromMoment, nextProps.toMoment);
      }
    } catch (err) {
      toast(this.props.languageObj.no_dates, {
        autoClose: 5000,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        hideProgressBar: true,
        className: "fail"
    })
      // Catch zero days
      // loadError = true;
    }
  }

  updateDimensions = () => {
    if (this.daysClipperRef != null) {
      const newPageSize = Math.floor((this.daysClipperRef.getBoundingClientRect().width) / 100);
      if (newPageSize !== this.state.pageSize) {
        this.setState({
          pageSize: Math.min(newPageSize, 7)
        });
      }
    }

    if (this.daysRef && this.daysClipperRef) {
      const sliderContentRect = this.daysRef.getBoundingClientRect();
      const sliderRect = this.daysClipperRef.getBoundingClientRect();
      const newContentSize = sliderContentRect.width;
      const newSize = sliderRect.width;

      if (newContentSize !== this.state.sliderContentSize || newSize !== this.state.sliderSize) {
        if (this.state.sliderPosition < Math.min(newSize - newContentSize, 0)) {
          const newPosition = Math.min(newSize - newContentSize, 0);
          this.scroll(newPosition);
        }
        this.setState({
          sliderContentSize: newContentSize,
          sliderSize: newSize
        });
      }
    }

  }

  // days: moment.Moment[]
  // from/to: moment.Moment
  processDays(days, from, to) {
    if (days && days.length > 0) {
      const firstDay = from;
      const lastDay = days[days.length - 1];
      const monthMin = firstDay.month();
      const monthMax = lastDay.month();

      // newMonthLists[][]/newDayList[]: {date: moment.Moment, disabled: boolean, month: number, clicked: boolean}
      const newMonthLists = [];
      const newDayList = [];

      const curDay = moment(from).startOf('day');
      for (let i = monthMin; i !== Utils.mod(monthMax + 1, 12); i = Utils.mod(++i, 12)) {
        // dayList[]: {date: moment.Moment, disabled: boolean, month: number, clicked: boolean}
        const dayList = [];
        while (curDay.month() === i) {
          // check disabled (this algorithm is slow but simple)
          let disabled = true;
          for (let j = 0; j < this.props.enabledDays.length; j++) {
            const enabledDay = this.props.enabledDays[j];
            if (enabledDay.isSame(curDay, 'day')) {
              disabled = false;
              break;
            }
          }
          // console.log('date added:', moment(curDay).format());
          // console.log('date added utc:', moment(curDay).utc().add(curDay.utcOffset(), 'm').format());
          dayList.push({
            date: moment(curDay),
            disabled: disabled,
            month: curDay.month(),
            clicked: false
          });
          newDayList.push({
            date: moment(curDay),
            disabled: disabled,
            month: curDay.month(),
            clicked: false
          });
          if (i === monthMax && curDay.isSame(to, 'day')) {
            break;
          }
          curDay.add(1, 'day');
        }
        curDay.startOf('month');
        newMonthLists[i] = dayList;
      }

      this.setState({
        monthMin: firstDay,
        monthMax: lastDay,
        currentMonth: firstDay,
        monthLists: newMonthLists
      });
    }
  }

  isMonthPrevDisabled() {
    const currentMonths = this.state.currentMonth.month() + this.state.currentMonth.year() * 12;
    const minMonths = this.state.monthMin.month() + this.state.monthMin.year() * 12;
    return currentMonths <= minMonths;
  }

  isMonthNextDisabled() {
    const currentMonths = this.state.currentMonth.month() + this.state.currentMonth.year() * 12;
    const maxMonths = this.state.monthMax.month() + this.state.monthMax.year() * 12;
    return currentMonths >= maxMonths;
  }

  isDaysPrevDisabled() {
    return !(this.state.sliderPosition < 0);
  }

  isDaysNextDisabled() {
    return !(this.state.sliderPosition > Math.min(this.state.sliderSize - this.state.sliderContentSize, 0));
  }

  onClickMonthPrev = () => {
    if (this.isMonthPrevDisabled() === false) {
      this.setState({
        currentMonth: this.state.monthLists[Utils.mod(this.state.currentMonth.month() - 1, 12)][0].date,
        sliderPosition: 0
      });
    }
  }

  onClickMonthNext = () => {
    if (this.isMonthNextDisabled() === false) {
      this.setState({
        currentMonth: this.state.monthLists[Utils.mod(this.state.currentMonth.month() + 1, 12)][0].date,
        sliderPosition: 0
      });
    }
  }

  onClickDaysPrev = () => {
    if (this.isDaysPrevDisabled() === false) {
      const numChildren = this.state.monthLists[this.state.currentMonth.month()].length;
      const avgItemSize = Math.floor(this.state.sliderContentSize / numChildren);
      const toPosition = Math.min(this.state.sliderPosition + avgItemSize * this.state.pageSize, 0);
      this.scroll(toPosition);
    }
  }

  onClickDaysNext = () => {
    if (this.isDaysNextDisabled() === false) {
      const numChildren = this.state.monthLists[this.state.currentMonth.month()].length;
      const avgItemSize = Math.floor(this.state.sliderContentSize / numChildren);
      const extent = Math.min(this.state.sliderSize - this.state.sliderContentSize, 0);
      const toPosition = Math.max(this.state.sliderPosition - avgItemSize * this.state.pageSize, extent);
      this.scroll(toPosition);
    }
  }

  // day: {date: moment.Moment, disabled: boolean, month: number, clicked: boolean}
  // index/month: number
  onClickDay = (day, index, month) => {

    const newMonthLists = this.state.monthLists.slice();
    if (newMonthLists[month][index].disabled && newMonthLists[month][index].clicked) {
      newMonthLists[month][index].clicked = false;
    } else {
      newMonthLists[month][index].clicked = true;
    }

    this.props.handleSelectDay(day);
    this.setState({
      monthLists: newMonthLists
    });
    this.props.saveSliderPosition(this.state.sliderPosition);
  }

  autoScroll() {
    let snapPosition = null;
    if (this.state.sliderPosition > 0) {
      snapPosition = 0;
    }
    else if (this.state.sliderPosition < Math.min(this.state.sliderSize - this.state.sliderContentSize, 0)) {
      snapPosition = Math.min(this.state.sliderSize - this.state.sliderContentSize, 0);
    }
    if (snapPosition != null) {
      this.scroll(snapPosition);
    }
  }

  // toPosition: number
  scroll(toPosition) {
    this.setState({
      sliderOldPosition: this.state.sliderPosition,
      snapPosition: toPosition,
      snapAmount: 0
    }, () => {
      this.cancelScroll();
      this.autoInterval = window.setInterval(() => {
        const newSnapAmount = Math.min(this.state.snapAmount + scrollTickInterval / this.state.snapDuration, 1);
        const delta = (this.state.snapPosition - this.state.sliderOldPosition) * Utils.easeInOutCubic(newSnapAmount);
        if (newSnapAmount === 1) {
          this.cancelScroll();
        }
        this.setState({
          snapAmount: newSnapAmount,
          sliderPosition: this.state.sliderOldPosition + delta
        });
      }, scrollTickInterval);
    });
  }

  cancelScroll() {
    window.clearInterval(this.autoInterval);
  }

  // e: MouseEvent
  onWindowMouseUp = e => {
    window.removeEventListener(this.moveEvent, this.onMovePressed);
    window.removeEventListener(this.endEvent, this.onWindowMouseUp);
    (this.onMovePressed).flush();
    this.autoScroll();
  }

  // e: MouseEvent
  onWindowTouchEnd = e => {
    window.removeEventListener(this.moveEvent, this.onTouchMove);
    window.removeEventListener(this.endEvent, this.onWindowTouchEnd);
    (this.onTouchMove).flush();
    this.autoScroll();
  }

  // e: MouseEvent
  onMovePressed = e => {
    this.cancelScroll();
    let delta = e.pageX - this.state.sliderDownPosition;

    if (Math.abs(delta) > 10 && this.state.sliding === false) {
      this.setState({
        sliding: true,
        sliderPosition: this.state.sliderOldPosition + delta
      });
    }
    else if (this.state.sliding) {
      this.setState({
        sliderPosition: this.state.sliderOldPosition + delta
      });
    }
  }

  // e: TouchEvent
  onTouchMove = e => {
    const touch = e.touches[0];
    this.cancelScroll();
    let delta = touch.pageX - this.state.sliderDownPosition;

    if (Math.abs(delta) > 10 && this.state.sliding === false) {
      this.setState({
        sliding: true,
        sliderPosition: this.state.sliderOldPosition + delta
      });
    }
    else if (this.state.sliding) {
      this.setState({
        sliderPosition: this.state.sliderOldPosition + delta
      });
    }
  }

  onMouseDown = e => {
    window.setTimeout(this.updateDimensions, 40);
    this.setState({
      sliderOldPosition: this.state.sliderPosition,
      sliderDownPosition: e.pageX,
      sliding: false
    }, () => {
      // remove the listeners first in case strays are lying around
      window.removeEventListener(this.moveEvent, this.onMovePressed);
      window.removeEventListener(this.endEvent, this.onWindowMouseUp);

      window.addEventListener(this.moveEvent, this.onMovePressed);
      window.addEventListener(this.endEvent, this.onWindowMouseUp);
    });
  }

  onTouchStart = e => {
    window.setTimeout(this.updateDimensions, 40);
    const touch = e.touches[0];
    this.setState({
      sliderOldPosition: this.state.sliderPosition,
      sliderDownPosition: touch.pageX,
      sliding: false
    }, () => {
      // remove the listeners first in case strays are lying around
      window.removeEventListener(this.moveEvent, this.onTouchMove);
      window.removeEventListener(this.endEvent, this.onWindowTouchEnd);

      window.addEventListener(this.moveEvent, this.onTouchMove);
      window.addEventListener(this.endEvent, this.onWindowTouchEnd);
    });
  }

  onMouseUp = () => {
    window.setTimeout(this.updateDimensions, 100);
  }

  onClickCapture = e => {
    if (this.state.sliding) {
      e.stopPropagation();
    }
  }

  render() {
    if (this.state.monthLists[this.state.currentMonth.month()] === undefined) return null;

    const monthList = this.state.monthLists[this.state.currentMonth.month()];
    // const monthList = this.state.monthLists[this.props.selectedDay ? this.props.selectedDay.month() : this.state.currentMonth.month()];

    const days = [];
    monthList.forEach((day, index) => {
      const daySelected = this.props.selectedDay && day.date.isSame(this.props.selectedDay, 'day');
      let daySrc = `${process.env.PUBLIC_URL}/images/DateCube.png`;
      if (day.disabled) {
        daySrc = `${process.env.PUBLIC_URL}/images/DateCubeDisabled.png`;
      }
      else if (daySelected) {
        daySrc = `${process.env.PUBLIC_URL}/images/DateCubeSelected.png`;
      }
      const dayClasses = classNames('DaySelector-day', {
        'DaySelector-day--disabled': day.disabled,
        'DaySelector-day--selected': daySelected,
        'DaySelector-day--clicked': day.clicked
      });
      days.push(
        <div className={dayClasses} key={index}>
          <div className={'DaySelector-dayFlex'}>
            {daySelected ? (
              <div className={'DaySelector-selected'}>
                {this.props.languageObj.render.selected}
              </div>
            ) : day.date.isSame(moment(), 'day')
                ? (
                  <div className={'DaySelector-today'}>
                    {this.props.languageObj.render.today}
                  </div>
                )
                : <div className={'DaySelector-daySpacer'}>{}</div>
            }
            <div className={'DaySelector-dayContainer'} onClick={this.onClickDay.bind(this, day, index, this.state.currentMonth.month())}>
              <img alt={'DaySelector-dayBackground'} className={'DaySelector-dayBackground'} src={daySrc} />
              {daySelected && (
                <img alt={'DaySelector-dayBackBackground'} className={'DaySelector-dayBackBackground'} src={`${process.env.PUBLIC_URL}/images/DateCube.png`} />
              )}
              <div className={'DaySelector-dayText'}>
                <div className={'DaySelector-dayWord'}>{day.date.locale(this.props.languageAbrev).format('ddd').toUpperCase()}</div>
                <div className={'DaySelector-dayNumber'}>{day.date.format('DD')}</div>
              </div>
            </div>
            {day.disabled
              ? (
                <div className={'DaySelector-today'}>
                  {this.props.languageObj.render.closed}
                </div>
              )
              : <div className={'DaySelector-daySpacer'}>{}</div>
            }
          </div>
        </div>
      );
    });

    const monthPrevClasses = classNames('DaySelector-monthPrev', {
      'DaySelector-monthPrev--disabled': this.isMonthPrevDisabled()
    });
    const monthNextClasses = classNames('DaySelector-monthNext', {
      'DaySelector-monthPrev--disabled': this.isMonthNextDisabled(),
      'DaySelector-monthNext--pulse': this.isDaysNextDisabled() && !this.isMonthNextDisabled()
    });
    const daysPrevClasses = classNames('DaySelector-daysPrev', {
      'DaySelector-daysPrev--disabled': this.isDaysPrevDisabled()
    });
    const daysNextClasses = classNames('DaySelector-daysNext', {
      'DaySelector-daysNext--disabled': this.isDaysNextDisabled()
    });

    const sliderContentStyle = {
      left: this.state.sliderPosition
    };

    return (
      <div className={'DaySelector'}>
        <ToastContainer
          className={'ToastContainer'}
          toastClassName={'Toast'}
          progressClassName={'ToastError'}
          position={'top-center'}
          newestOnTop={true}
          rtl={false}
        />
        <div className={'DaySelector-monthContainer'} ref={(x) => { this.daysRef = x; }}>
          <div className={'DaySelector-monthSpacer'}>{}</div>
          <img alt={'monthPrevClasses'} className={monthPrevClasses} onClick={this.onClickMonthPrev} src={`${process.env.PUBLIC_URL}/images/icons/ArrowLeft.png`} />
          <div className={'DaySelector-monthSpacer'}>{}</div>
          <div className={'DaySelector-month'}>
            {this.state.currentMonth.locale(this.props.languageAbrev).format('MMMM').toUpperCase()}
          </div>
          <div className={'DaySelector-monthSpacer'}>{}</div>
          <img alt={'monthNextClasses'} className={monthNextClasses} onClick={this.onClickMonthNext} src={`${process.env.PUBLIC_URL}/images/icons/ArrowRight.png`} />
          <div className={'DaySelector-monthSpacer'}>{}</div>
        </div>
        <div className={'DaySelector-daysContainer'}>
          <div className={'DaySelector-daysSpacer'}>{}</div>
          <img
            alt={'dasPrevClasses'}
            className={daysPrevClasses}
            onClick={this.onClickDaysPrev}
            src={`${process.env.PUBLIC_URL}/images/icons/ArrowLeftBlue.png`}
          />
          <div
            className={'DaySelector-daysClipper'}
            ref={(x) => { this.daysClipperRef = x; }}
            onMouseDown={this.isTouch ? undefined : this.onMouseDown}
            onTouchStart={this.isTouch ? this.onTouchStart : undefined}
            onClickCapture={this.onClickCapture}
            onMouseUp={this.onMouseUp}
          >
            <div className={'DaySelector-days'} ref={(x) => { this.daysRef = x; }} style={sliderContentStyle}>
              {days}
            </div>
          </div>
          <img
            alt={'daysNextClasses'}
            className={daysNextClasses}
            onClick={this.onClickDaysNext}
            src={`${process.env.PUBLIC_URL}/images/icons/ArrowRightBlue.png`}
          />
          <div className={'DaySelector-daysSpacer'}>{}</div>
        </div>
      </div>
    );
  }
})
